const CameraFill = ({ color = 'white' }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.6667 10.8333C10.6667 12.03 9.69668 13 8.50001 13H3.50001C2.30334 13 1.33334 12.03 1.33334 10.8333V5.16667C1.33334 3.97 2.30334 3 3.50001 3H8.50001C9.69668 3 10.6667 3.97 10.6667 5.16667V10.8333ZM14.413 4.39833C14.2563 4.30967 14.064 4.312 13.9093 4.40467L11.3333 5.95033V10.0497L13.9097 11.5953C13.9887 11.643 14.0773 11.6667 14.1667 11.6667C14.2517 11.6667 14.3367 11.645 14.413 11.6017C14.5697 11.513 14.6667 11.347 14.6667 11.1667V4.83333C14.6667 4.653 14.5697 4.487 14.413 4.39833Z" fill="#9CA3AF"/>
</svg>

)

export default CameraFill
